<template>
  <PageBase title="Ambitiethema uitbreidbaarheid" description="" :valid="valid" @show-error="showError" :right-button-classes="'mr-12'" :show-right-margin="false">
    <div class="flex gap-4 xl:-mt-6 mr-12">
      <div class="flex-1"></div>
        <div class="text-base -mt-2 text-right w-64 xl:w-auto xl:mt-2">Horizontale uitbreidbaarheid meenemen in de aanvraag?</div>

        <JaNeeToggleButton v-model="store.registrationData.prioriteringsThemas.horizontaleUitbreiding" />
      </div>
      <div class="flex gap-4 xl:-mt-3 mr-12">
      <div class="flex-1"></div>
        <div class="text-base -mt-2 text-right w-64 xl:w-auto xl:mt-2">Verticale uitbreidbaarheid meenemen in de aanvraag?</div>

        <JaNeeToggleButton v-model="store.registrationData.prioriteringsThemas.verticaleUitbreiding" />
      </div>

    <div class="flex flex-col gap-3 max-h-[calc(100vh-270px)] overflow-y-auto overflow-x-hidden pr-12">

<div class="flex flex-col-reverse lg:flex-row gap-5">
          <div class="flex-1">
            <img class="object-contain" src="/src/assets/Uitbreidbaarheid.png" />
          </div>
          <div class="flex-1 flex flex-col gap-4">
            <div class="text-sm italic">Het generieke Programma van Eisen (PvE) voor scholen biedt een
flexibel raamwerk dat eenvoudig kan worden afgestemd op de
specifieke wensen van gemeenten en schoolbesturen. Dit gebeurt
aan de hand van verschillende ambitie-opties, zoals de optie
voor uitbreidbaarheid. Deze keuze faciliteert toekomstige groei in
leerlingenaantallen of veranderende onderwijsbehoeften.
      </div>

      <div class="text-sm">Bij uitbreidbaarheid kan worden gekozen voor horizontale of
verticale uitbreiding, afhankelijk van locatie, stedenbouwkundige
inpassing en wensen van betrokken partijen. Horizontale uitbreiding
voegt min 10% m2 BVO op maaiveldniveau toe. Dit vereist meer
ruimte op de kavel en is daarom alleen geschikt voor locaties met
voldoende beschikbaar terrein.</div>

      <div class="text-sm">Verticale uitbreiding voegt min 10% m2 BVO toe als (gedeeltelijke)
extra bouwlaag. Verticale uitbreiding vraagt om een hogere initiële
kosten, maar is bij goede voorbereiding in de toekomst eenvoudiger
uit te voeren. In beide gevallen houdt het ontwerp rekening met de
voor- en na-situatie, zodat de uitbreiding efficiënt en zonder al te
veel overlast kan worden uitgevoerd.</div>

            <InformationDialog title="Horizontale uitbreidbaarheid" button-title="Meer Informatie over Horizontale Uitbreidbaarheid" :content="meetInformatieHorizontaal" />
            <InformationDialog title="Verticale uitbreidbaarheid" button-title="Meer Informatie over Verticale Uitbreidbaarheid" :content="meerInformatieVerticaal" />
          </div>
        </div>
    </div>
  </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue';
import InformationDialog from '@/components/InformationDialog.vue';
import JaNeeToggleButton from '@/components/JaNeeToggleButton.vue';
import { useRegistrationStore } from '@/stores/registration'
import { ref } from 'vue';

const store = useRegistrationStore()
const errorsShown = ref(false)
const valid = ref(true)

const meetInformatieHorizontaal = `<div class="text-sm font-bold italic text-justify">Ruimtelijke inrichting en plattegrond</div>
          <ul class="text-sm list-disc ml-5">
              <li>Ruimte rondom het gebouw moet worden gereserveerd voor
                toekomstige uitbreiding.</li>
              <li>Inrichting van de ruimtes, de posities van entrees, ramen en
      buitenspeelruimtes worden zodanig ontworpen om toekomstige
      aanbouw mogelijk te maken.</li>
            </ul>

            <div class="text-sm font-bold italic mt-4">Bouwkundig en constructief</div>
            <ul class="text-sm list-disc ml-5">
              <li>De gevel t.p.v. de uitbreiding wordt demontabel ontworpen,
                zodat deze kan worden losgehaald en worden hergebruikt.</li>
              <li>Extra aandacht voor brandveiligheidseisen, zoals brandwerende
                materialen en vluchtroutes.</li>
                <li>De fundering t.p.v. de gevel waar uitgebreidt wordt en het
      omliggende terrein moeten geschikt worden gemaakt voor
      uitbreiding.</li>
            </ul>`
const meerInformatieVerticaal = `<div class="text-sm font-bold italic text-justify">Ruimtelijke inrichting en plattegrond</div>
          <ul class="text-sm list-disc ml-5">
            <li>Een gedeelte van de verdieping het gebouw moet worden
    gereserveerd voor toekomstige uitbreiding of een gehele
    verdieping kan worden toegevoegd bij toekomstige uitbreiding.
    Inrichting van de ruimtes, de posities van trappen en ramen
    worden zodanig ontworpen dat toekomstige verticale
    uitbreiding mogelijk is.</li>
            <li>De uitbreiding moet passen bij de visuele aansluiting met
              bestaande bebouwing.</li>
            <li>Beoordeling van schaduwvorming, impact op zichtlijnen en
              hoogtebeperkingen binnen de omgeving.</li>
          </ul>

          <div class="text-sm font-bold italic mt-4">Bouwkundig en constructief</div>
          <ul class="text-sm list-disc ml-5">
            <li>De gevel t.p.v. de uitbreiding wordt demontabel ontworpen,
              zodat deze kan worden losgehaald en worden hergebruikt.</li>
            <li>Dakbedekking, isolatie en andere voorzieningen op het dak
              kunnen eenvoudig worden verwijderd.</li>
            <li>Extra aandacht voor brandveiligheidseisen, zoals brandwerende
              materialen en vluchtroutes.</li>
            <li>Trappenhuizen en liften zijn voorbereidt op uitbreiding of
              eenvoudig aan te passen.</li>
            <li>Het gebouw krijgt een zwaardere fundering en constructie
    om het extra gewicht van een toekomstige uitbreiding op de
    verdieping te kunnen dragen.</li>
          </ul>

        <div class="text-sm font-bold mt-4">Installaties</div>
        <div class="text-sm">In beide varianten dient de gebouw gebonden installatie te worden
  ontworpen met voldoende reservecapaciteit en een modulaire,
  demontabele opzet.</div>`

  function showError() {
    errorsShown.value = true
  }
</script>
